<template lang="html">

  <div class="home">

    <section class="vh intro">

      <a href="#" v-scroll-to="'.texto-intro-home'" class="scrolldown"></a>

      <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
        <div class="container-text">
          <h2 class="title title-52" v-html="$t('home.titulo')" ></h2>
          <a class="btn btn-light open-pop" @click="setVideo"  v-html="$t('home.boton_video')">Ver vídeo</a>
          
        </div>
      </div>
      
    </section>

    <section class="texto-intro-home">

      <div class="container">

        <p v-html="$t('home.entradilla')" ></p>

      </div>

    </section>


    <section class="calidad-1">
      <div class="container">
        <div class="title_creamos">
          <h2 class="title"> 
            <span v-html="$t('home.seccionCreamos.creamos')"  class="first bold title-114 waypoints"></span>
            <span class="second waypoints" v-html="$t('home.seccionCreamos.futuro')"></span>
            <span class="fourth waypoints" v-html="$t('home.seccionCreamos.sostenible')"></span>
          </h2>
        </div>
        
        <div class="flex row-reserve justify-end psr flecha-container">
          <img alt="seguir leyendo" v-scroll-to="'.stats'" class="flecha" src="/static/img/flecha_blanca.svg" >
          <p v-html="$t('home.seccionCreamos.description')"></p>
        </div>
      </div>
    </section>

    <section class="stats row-center">



      <article class="stat -quienes-somos ">
        <router-link :to="$t('enlaces.ajusath')">
          <div class="contenedor-texto column-between container-hover" >
            <div class="cerrado" :show="quienes_somos">
             <h2 v-html="$t('home.seccionPie.quienessomos.title')"></h2>
             <button class="show" ></button>
           </div>
           <div class="abierto">
            <h2 v-html="$t('home.seccionPie.quienessomos.title')"></h2>
            <p v-html="$t('home.seccionPie.quienessomos.description')"></p>
            <button ></button>
          </div>
        </div>
      </router-link>
    </article>


    <article class="stat -tecnologia ">
      <router-link :to="$t('enlaces.tecnologia')">
        <div class="contenedor-texto column-between container-hover" >
          <div class="cerrado" :show="quienes_somos">
           <h2 v-html="$t('home.seccionPie.tecnologia.title')"></h2>
           <button class="show" ></button>
         </div>
         <div class="abierto">
          <h2 v-html="$t('home.seccionPie.tecnologia.title')"></h2>
          <p v-html="$t('home.seccionPie.tecnologia.description')"></p>
          <button ></button>
        </div>
      </div>
    </router-link>
  </article>

  <article class="stat -productos ">
    <router-link :to="$t('enlaces.productos')">
      <div class="contenedor-texto column-between container-hover" >
        <div class="cerrado" :show="quienes_somos">
         <h2 v-html="$t('home.seccionPie.productos.title')"></h2>
         <button class="show" ></button>
       </div>
       <div class="abierto">
        <h2 v-html="$t('home.seccionPie.productos.title')"></h2>
        <p v-html="$t('home.seccionPie.productos.description')"></p>
        <button ></button>
      </div>
    </div>
  </router-link>
</article>



</section>


<video-visualizer :id="videoid" :show="videoshow" @closeVideo="eraseVideo"></video-visualizer>


</div>

</template>

<script lang="js">

  import videoVisualizer from '@/components/parts/video-visualizer'

  export default  {
    name: 'home',
    props: [],
    mounted() {

    },
    components : {
      'video-visualizer' : videoVisualizer
    },
    data() {
      return {
        videoshow : false,
        quienes_somos: false,
        tecnologia: false,
        productos :false,
        abierto :false,
        videoid : 'rlLLwy5cURk'

      }


    },
    methods: {
      setVideo(){
        this.videoshow = true;
        this.videoid = 'rlLLwy5cURk'
      },
      eraseVideo(){
        this.videoshow = false;
        this.videoid  = '';
      }
    },
    computed: {

    }
  }
</script>

<style scoped>
.stats{
  width: 100%;
}

.stat{
  width: 33.333333%;
  min-height: 600px;
}
.container-hover{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  } .container-hover:hover .abierto{   
    display: flex;   
    transition: .5s;
    opacity: 1;

  }
  .container-hover:hover .cerrado{
    transition: .5s;
    opacity: 0;

  }
  .container-hover .cerrado{
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 30%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    transition: .5s;
    opacity: 1;
  }
  .-quienes-somos  .cerrado,  .-quienes-somos  .abierto{
    background-color:rgba(5,66,121,.8);
  }
  .-tecnologia  .cerrado, .-tecnologia  .abierto{
   background-color: rgba(2,32,60,.9);
 }
 .-productos  .cerrado,  .-productos  .abierto{
  background-color:rgba(205, 217, 228, .9);
}
.-productos  .cerrado, .-productos  .abierto{
 background-color: rgba(205, 217, 228, .9);
}

.container-hover .abierto{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  transition: .5s;
  opacity: 0;
  padding: 15px;


}
.stat .container-hover .abierto button{
  background: url(/static/img/less.svg) center/cover no-repeat;
}

.stat.-productos  .container-hover .abierto button{
  background: url(/static/img/less-gray.svg) center/cover no-repeat;
}

.stat.-tecnologia{
  background: url(/static/img/bkg/bkg-tecnologia.jpg) center/cover no-repeat;
}

.stat.-quienes-somos{
  background: url(/static/img/ajusa/aj-intro.jpg) center/cover no-repeat;
}

.stat.-productos{
  background: url(/static/img/bkg/bkg-productos.jpg) center/cover no-repeat;
}

.stat .contenedor-texto{
  /*padding: 50px;*/
  /*background: rgba(5,66,121,.8);*/
  color: #fff;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 0;
  transition: .5s;
}

.stat .contenedor-texto[show="true"]{
  top: 0;
}


/*.stat.-quienes-somos .contenedor-texto{
  background: rgba(5,66,121,.8);
  }*/

  .stat.-tecnologia .contenedor-texto{
    color: white;
  }


  .stat.-productos .contenedor-texto *{
    color: #646464;
  }


  .stat .contenedor-texto h2{
    text-transform: uppercase;
    color: #cdd9e4;
    font-size: 24px;
    text-align: center;
    width: 100%;
    display: inline-block;
  }

  .stat .contenedor-texto p{
    text-align: center;
    font-size: 16px;
    margin: 0 25px;
  }

  .stat .contenedor-texto button{
    width: 60px;
    height: 60px;
    display: inline-block;
    background: url(/static/img/more.svg) center/cover no-repeat;
    border:none;
    margin:0 auto;
    outline: none;
    cursor:pointer;
    margin: 0 30px;
  }


  .stat .contenedor-texto[show="true"] button{
    background: url(/static/img/less.svg) center/cover no-repeat;
  }

  .stat.-productos .contenedor-texto button{
    background: url(/static/img/more-gray.svg) center/cover no-repeat;
  }




  .stat .contenedor-texto p{
    -webkit-transition: height .3s linear, padding-top .3s linear, padding-bottom .3s linear, border-top-width .3s linear, border-top-width .3s linear;
    transition: height .3s linear, padding-top .3s linear, padding-bottom .3s linear, border-top-width .3s linear, border-top-width .3s linear;
  }

  .stat .contenedor-texto p[hide="true"]{
    overflow: hidden;
    padding-top: 0;
    padding-bottom: 0;
    height: 0;
    border-width: 0 1px;
  }

  .texto-intro-home{
    padding: 100px 50px;
    background: url(/static/img/bkg-metal.jpg) center/cover no-repeat;
    text-align: center;
  }

  .texto-intro-home .container{
    max-width: 768px;
  }

  .calidad-1 .flecha{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%);
  }

  .calidad-1 .flecha-container{
    position: relative;
  }
  .title_creamos{
    transform: translateY(-25px);
  }

 @media screen and (max-width:1024px){
   .container-hover .abierto{
      opacity: 1;
      height: auto;
      bottom: 0;
      position: absolute;
      padding: 30px 10px;
    }
    .container-hover .cerrado{
      opacity: 0;
    }
    .stat .contenedor-texto button{
      width: 5px;
      height: 5px;
    }
 }



  @media screen and (max-width:800px){

    .calidad-1 p{
      text-align: center;
      margin-top: 20px;
    }

    .calidad-1 .flecha-container{
      padding-bottom: 40px;
    }

    .calidad-1 .flecha-container img{
      bottom: 0;
      top: auto;
      transform: translateY(0);
    }

    .stat{
      width: 100%;
      min-height: 50vh;
    }
    .stat .container-hover .abierto button{
      background: url(/static/img/more.svg) center/cover no-repeat;
    }

    .stat.-productos  .container-hover .abierto button{
      background: url(/static/img/more-gray.svg) center/cover no-repeat;
    }
    .container-hover .abierto{
      padding: 50px 15px;
    }
    .container-hover .abierto{
      opacity: 1;
      height: auto;
      bottom: 0;
      position: absolute;
    }
    .container-hover .cerrado{
      opacity: 0;
    }
    .stat .contenedor-texto button{
      width: 5px;
      height: 5px;
    }
    

  }
  @media screen and (max-width:500px){
    .texto-intro-home{
      padding:40px 0;
      text-align: left;
      padding-bottom: 75px;
    }
    
    .container-hover .abierto{
      padding: 25px 10px;
    }
    .stat .contenedor-texto button{
     display: none;
    }
    .container-hover .abierto{
      opacity: 1;
      height: 100%;
      bottom: 0;
      position: absolute;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/views/home.vue